import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import TwilioSegment from './components/TwilioSegment'
import Testimonial from './components/Testimonial'
import DelightYourCustomers from './components/DelightYourCustomers'
import CreateOneCustomerConversation from './components/CreateOneCustomerConversation'
import MakeEveryInteractionMeaningful from './components/MakeEveryInteractionMeaningful'
import LovedBy10MillionDevelopers from './components/LovedBy10MillionDevelopers'
import Signup from './components/Signup'
import Resources from './components/Resources'
import LogoCarousel from './components/LogoCarousel'

const TwilioSegmentView = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Unify Your Customer Data &amp; Experience With Segment + Twilio | Twilio Segment"
        pageDescription="Segment + Twilio together allow businesses to scale personalized, intelligent customer engagement with unified customer data."
      >
        <NavigationV2 />
        <Main>
          <Hero />
          <LogoCarousel />
          <TwilioSegment />
          <Testimonial />
          <DelightYourCustomers />
          <CreateOneCustomerConversation />
          <MakeEveryInteractionMeaningful />
          <LovedBy10MillionDevelopers />
          <Resources />
          <Signup />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-top: 0;
  }
`

export default TwilioSegmentView
